import React, { memo } from 'react'

import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'

import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import CancelBidSellerDialog from '../containers/CancelBidSellerDialog/CancelBidSellerDialog.container'
import CancelQuoteDialogContainer from '../containers/CancelQuoteDialog/CancelQuoteDialog.container'
import ExtendQuoteClosingDateDialogContainer from '../containers/ExtendQuoteClosingDateDialog/ExtendQuoteClosingDateDialog.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import QuoteBasicInformation from '../containers/QuoteBasicInformation/QuoteBasicInformation.container'
import QuoteBid from '../containers/QuoteBid/QuoteBid.container'
import QuoteBidSeeDetailDialog from '../containers/QuoteBidSeeDetailDialog/QuoteBidSeeDetailDialog.container'
import QuoteBidSellerContainer from '../containers/QuoteBidSeller/QuoteBidSeller.container'
import QuoteListProductsContainer from '../containers/QuoteListProducts/QuoteListProducts.container'
import QuoteListPurchaseOrderContainer from '../containers/QuoteListPurchaseOrder/QuoteListPurchaseOrder.container'
import QuoteRecordsDialogContainer from '../containers/QuoteRecordsDialog/QuoteRecordsDialog.container'
import SendSellerQuoteDialog from '../containers/SendSellerQuoteDialog/SendSellerQuoteDialog.container'

/**
 * The Quote Offer's page.
 */
const QuoteSummaryPage = memo(() => (
  <AuthorizationProviderContainer>
    <ProtectByAccessToken>
      <BrandLayout>
        <QuoteBasicInformation>
          <QuoteListProductsContainer />
          <QuoteListPurchaseOrderContainer />
        </QuoteBasicInformation>

        <QuoteBid />
        <QuoteBidSellerContainer />

        <SendSellerQuoteDialog />
        <ExtendQuoteClosingDateDialogContainer />
        <CancelQuoteDialogContainer />
        <QuoteBidSeeDetailDialog />
        <QuoteRecordsDialogContainer />
        <CancelBidSellerDialog />
        <OnboardingDialogContainer />
      </BrandLayout>
    </ProtectByAccessToken>
  </AuthorizationProviderContainer>
))

export default QuoteSummaryPage
